
// import React, { useState } from "react";
// import {
//   CalendarClock,
//   Sofa,
//   FlaskConical,
//   RefreshCcw,
//   Truck,
//   HelpCircle,
//   Scissors,
//   MessageSquare,
//   Timer,
//   Info,
//   ShieldCheck,
//   UserCheck,
//   PhoneCall,
//   PackageCheck,
//   Brush,
//   Smile,
//   ChevronDown,
//   ChevronUp,
// } from "lucide-react";

// const questions = [
//   {
//     icon: <CalendarClock size={16} />,
//     text: "Halılar kaç günde teslim ediliyor?",
//     answer: "Genellikle 2-3 iş günü içinde teslim edilir.",
//   },
//   {
//     icon: <Sofa size={16} />,
//     text: "Koltuk yıkama yerinde mi yapılıyor?",
//     answer: "Evet, koltuk yıkama işlemi yerinde yapılmaktadır.",
//   },
//   {
//     icon: <FlaskConical size={16} />,
//     text: "Kullandığınız deterjanlar sağlığa zararlı mı?",
//     answer: "Hayır, tamamen organik ve alerjen içermeyen ürünler kullanıyoruz.",
//   },
//   {
//     icon: <RefreshCcw size={16} />,
//     text: "Yorgan, battaniye de yıkıyor musunuz?",
//     answer: "Evet, yorgan ve battaniye temizliği de yapıyoruz.",
//   },
//   {
//     icon: <Truck size={16} />,
//     text: "Servis ücreti alınıyor mu?",
//     answer: "Hayır, servisimiz ücretsizdir.",
//   },
//   {
//     icon: <HelpCircle size={16} />,
//     text: "Hangi tür halılar yıkanır?",
//     answer: "Tüm makine halıları, shaggy, yün ve el dokuma halılar yıkanır.",
//   },
//   {
//     icon: <Scissors size={16} />,
//     text: "Halı tamiri/overlok yapıyor musunuz?",
//     answer: "Evet, isteğe bağlı olarak halı tamiri ve overlok hizmetimiz vardır.",
//   },
//   {
//     icon: <Timer size={16} />,
//     text: "Koltuklar ne kadar sürede kurur?",
//     answer: "Genellikle 4-6 saat içinde kurur.",
//   },
//   {
//     icon: <MessageSquare size={16} />,
//     text: "Halılar nasıl yıkanıyor?",
//     answer: "Tam otomatik makinelerde, hijyenik şartlarda yıkanır.",
//   },
//   {
//     icon: <Info size={16} />,
//     text: "Perde yıkama yapıyor musunuz?",
//     answer: "Evet, stor ve zebra perde yıkama hizmetimiz mevcuttur.",
//   },
//   {
//     icon: <ShieldCheck size={16} />,
//     text: "Antibakteriyel ürün mü kullanılıyor?",
//     answer: "Evet, her işlem antibakteriyel içeriklerle desteklenir.",
//   },
//   {
//     icon: <UserCheck size={16} />,
//     text: "Personeliniz yerinde hizmet veriyor mu?",
//     answer: "Evet, koltuk ve yatak temizliği yerinde yapılır.",
//   },
//   {
//     icon: <PhoneCall size={16} />,
//     text: "İletişim saatleriniz nedir?",
//     answer: "08:00 – 22:00 saatleri arasında hizmet veriyoruz.",
//   },
//   {
//     icon: <PackageCheck size={16} />,
//     text: "Paketleme nasıl yapılıyor?",
//     answer: "Halılar steril poşetlerle özenle paketlenir.",
//   },
//   {
//     icon: <Brush size={16} />,
//     text: "El dokuma halılar zarar görür mü?",
//     answer: "Hayır, özel tekniklerle zarar vermeden yıkanır.",
//   },
//   {
//     icon: <Smile size={16} />,
//     text: "Memnun kalmazsam ne olur?",
//     answer: "Koşulsuz memnuniyet garantisi sunuyoruz.",
//   },
// ];

// const FAQBox = () => {
//   const [openIndex, setOpenIndex] = useState(null);

//   const toggleAnswer = (index) => {
//     setOpenIndex(openIndex === index ? null : index);
//   };

//   return (
//     <section className="space-y-10 text-gray-800 text-base leading-loose text-justify">
//       <div className="space-y-3 border-b pb-4">
//         <h3 className="font-semibold text-lg text-[#00704A]">Sıkça Sorulan Sorular</h3>
//         <ul className="list-none space-y-4">
//           {questions.map((item, index) => (
//             <li key={index} className="border-b pb-4">
//               <button
//                 onClick={() => toggleAnswer(index)}
//                 className="flex items-center justify-between w-full text-left hover:text-green-600 transition"
//               >
//                 <div className="flex items-center gap-2">
//                   {item.icon}
//                   <span className="font-medium">{item.text}</span>
//                 </div>
//                 {openIndex === index ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
//               </button>
//               {openIndex === index && (
//                 <p className="mt-2 text-sm text-gray-700">{item.answer}</p>
//               )}
//             </li>
//           ))}
//         </ul>
//       </div>
//     </section>
//   );
// };

// export default FAQBox;
import React, { useState } from "react";
import {
  CalendarClock,
  Sofa,
  FlaskConical,
  RefreshCcw,
  Truck,
  HelpCircle,
  Scissors,
  MessageSquare,
  Timer,
  Info,
  ShieldCheck,
  UserCheck,
  PhoneCall,
  PackageCheck,
  Brush,
  Smile,
  ChevronDown,
} from "lucide-react";

const questions = [
  {
    icon: <CalendarClock size={17} />,
    text: "Halılar kaç günde teslim ediliyor?",
    answer: "Halılarınız genellikle 2-3 iş günü içinde hijyenik şekilde temizlenip adresinize teslim edilir.",
  },
  {
    icon: <Sofa size={17} />,
    text: "Koltuk yıkama yerinde mi yapılıyor?",
    answer: "Evet, koltuk yıkama işlemi profesyonel ekipmanlarla adresinizde, yerinde yapılmaktadır.",
  },
  {
    icon: <FlaskConical size={17} />,
    text: "Kullandığınız deterjanlar sağlığa zararlı mı?",
    answer: "Hayır, temizlik işlemlerinde sağlığa uygun, kaliteli ve güvenilir temizlik ürünleri kullanıyoruz.",
  },
  {
    icon: <RefreshCcw size={17} />,
    text: "Yorgan, battaniye de yıkıyor musunuz?",
    answer: "Evet, yorgan ve battaniyeleriniz özel yıkama programlarıyla hijyenik şekilde temizlenir.",
  },
  {
    icon: <Truck size={17} />,
    text: "Servis ücreti alınıyor mu?",
    answer: "Hayır, belirlenen servis bölgelerinde adresten alım ve teslimat ücretsizdir.",
  },
  {
    icon: <HelpCircle size={17} />,
    text: "Hangi tür halılar yıkanır?",
    answer: "Makine halısı, shaggy, yün, akrilik ve hassas yapıdaki birçok halı türü özenle yıkanır.",
  },
  {
    icon: <Scissors size={17} />,
    text: "Halı tamiri/overlok yapıyor musunuz?",
    answer: "Evet, ihtiyaç durumunda halı tamiri, saçak bakımı ve overlok hizmeti de sunuyoruz.",
  },
  {
    icon: <Timer size={17} />,
    text: "Koltuklar ne kadar sürede kurur?",
    answer: "Koltuklar ortam sıcaklığına ve havalandırmaya bağlı olarak ortalama 4-6 saat içinde kurur.",
  },
  {
    icon: <MessageSquare size={17} />,
    text: "Halılar nasıl yıkanıyor?",
    answer: "Halılarınız toz alma, leke ön işlem, profesyonel yıkama, durulama, sıkma ve kurutma aşamalarından geçirilir.",
  },
  {
    icon: <Info size={17} />,
    text: "Perde yıkama yapıyor musunuz?",
    answer: "Evet, stor ve zebra perde temizliği profesyonel yöntemlerle yapılmaktadır.",
  },
  {
    icon: <ShieldCheck size={17} />,
    text: "Antibakteriyel ürün mü kullanılıyor?",
    answer: "Evet, temizlik sürecinde hijyeni destekleyen antibakteriyel içerikli ürünler tercih edilir.",
  },
  {
    icon: <UserCheck size={17} />,
    text: "Personeliniz yerinde hizmet veriyor mu?",
    answer: "Evet, koltuk, yatak ve yerinde yıkama hizmetlerinde ekibimiz adresinize gelerek işlem yapar.",
  },
  {
    icon: <PhoneCall size={17} />,
    text: "İletişim saatleriniz nedir?",
    answer: "08:00 – 22:00 saatleri arasında telefon ve WhatsApp üzerinden bizimle iletişime geçebilirsiniz.",
  },
  {
    icon: <PackageCheck size={17} />,
    text: "Paketleme nasıl yapılıyor?",
    answer: "Yıkama ve kurutma işlemi tamamlanan halılarınız hijyenik ambalajlarla özenle paketlenir.",
  },
  {
    icon: <Brush size={17} />,
    text: "El dokuma halılar zarar görür mü?",
    answer: "El dokuma ve hassas halılar, ürün yapısına uygun özel temizlik yöntemleriyle zarar verilmeden temizlenir.",
  },
  {
    icon: <Smile size={17} />,
    text: "Memnun kalmazsam ne olur?",
    answer: "Müşteri memnuniyeti bizim için önceliklidir. Herhangi bir sorun yaşamanız durumunda çözüm odaklı destek sağlarız.",
  },
];

const FAQBox = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="rounded-[32px] border border-[#EADBCB] bg-gradient-to-br from-[#FFF9F3] via-[#FFFDFB] to-[#F6EBDD] p-5 md:p-7 shadow-[0_12px_40px_rgba(0,0,0,0.05)]">
      <div className="mb-7 text-center">
        <span className="inline-flex items-center justify-center rounded-full border border-[#D8C2A8] bg-white/80 px-4 py-2 text-[11px] font-bold uppercase tracking-[2px] text-[#B07A3F]">
          Merak Edilenler
        </span>

        <h3 className="mt-4 text-2xl md:text-3xl font-black text-[#0E2A47]">
          Sıkça Sorulan Sorular
        </h3>

        <p className="mx-auto mt-3 max-w-xl text-sm leading-7 text-[#6A625A]">
          Hizmetlerimiz, teslimat süreci ve temizlik yöntemlerimiz hakkında en
          çok sorulan soruları sizin için cevapladık.
        </p>
      </div>

      <div className="space-y-3">
        {questions.map((item, index) => {
          const isOpen = openIndex === index;

          return (
            <div
              key={index}
              className={`overflow-hidden rounded-2xl border transition-all duration-300 ${
                isOpen
                  ? "border-[#C18A4A] bg-white shadow-[0_10px_30px_rgba(0,0,0,0.07)]"
                  : "border-[#EFE2D4] bg-white/70 hover:border-[#D7B487] hover:bg-white"
              }`}
            >
              <button
                type="button"
                onClick={() => toggleAnswer(index)}
                className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left"
              >
                <div className="flex items-center gap-3">
                  <span
                    className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl transition-all duration-300 ${
                      isOpen
                        ? "bg-[#0E2A47] text-white"
                        : "bg-[#FFF4E8] text-[#B07A3F]"
                    }`}
                  >
                    {item.icon}
                  </span>

                  <span
                    className={`text-sm md:text-[15px] font-bold leading-6 ${
                      isOpen ? "text-[#0E2A47]" : "text-[#3F3832]"
                    }`}
                  >
                    {item.text}
                  </span>
                </div>

                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all duration-300 ${
                    isOpen
                      ? "rotate-180 bg-[#C18A4A] text-white"
                      : "bg-[#F8EFE5] text-[#B07A3F]"
                  }`}
                >
                  <ChevronDown size={17} />
                </span>
              </button>

              <div
                className={`grid transition-all duration-300 ease-in-out ${
                  isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                }`}
              >
                <div className="overflow-hidden">
                  <p className="border-t border-[#EFE2D4] px-4 py-4 pl-[68px] text-sm leading-7 text-[#655C55]">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FAQBox;